import React from "react";
import Tray from "../Video";

const ConceptTray = props => {
  return (
    <div className="netflix-tray">
      <Tray
        {...props}
        showCount={false}
        netflix={true}
        hideCategories={false}
        onlyPrimaryCategory={false}
        draggable={false}
        neouTrayTitle={true}
      />
    </div>
  );
};

export default ConceptTray;
